/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs */

const en_onboarding_paywall_benefit_custom_app_block_list = /** @type {(inputs: Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Block distracting apps, focus beyond willpower`)
};

const ar_onboarding_paywall_benefit_custom_app_block_list = /** @type {(inputs: Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حظر التطبيقات المشتتة للانتباه، والتركيز على ما هو أبعد من قوة الإرادة`)
};

const de_onboarding_paywall_benefit_custom_app_block_list = /** @type {(inputs: Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablenkende Apps blockieren, Konzentration jenseits der Willenskraft`)
};

const es_onboarding_paywall_benefit_custom_app_block_list = /** @type {(inputs: Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquea las apps que te distraen y concéntrate más allá de la fuerza de voluntad`)
};

const fr_onboarding_paywall_benefit_custom_app_block_list = /** @type {(inputs: Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquez les applications distrayantes, concentrez-vous sans effort.`)
};

const it_onboarding_paywall_benefit_custom_app_block_list = /** @type {(inputs: Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocca le app che distraggono, concentrati oltre la forza di volontà`)
};

const ja_onboarding_paywall_benefit_custom_app_block_list = /** @type {(inputs: Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`気が散るアプリをブロックして、意志の力を超えた集中を実現`)
};

const ko_onboarding_paywall_benefit_custom_app_block_list = /** @type {(inputs: Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방해가 되는 앱을 차단하고 집중 의지를 다지세요`)
};

const pt_br_onboarding_paywall_benefit_custom_app_block_list = /** @type {(inputs: Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueie os aplicativos que causam distrações, vá além da força de vontade para manter o foco`)
};

const ru_onboarding_paywall_benefit_custom_app_block_list = /** @type {(inputs: Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Блокируйте отвлекающие приложения, фокусируйтесь без усилий`)
};

const th_onboarding_paywall_benefit_custom_app_block_list = /** @type {(inputs: Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บล็อกแอปที่รบกวนสมาธิ โฟกัสได้มากกว่าที่ตั้งใจไว้`)
};

const tr_onboarding_paywall_benefit_custom_app_block_list = /** @type {(inputs: Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dikkat dağıtıcı uygulamaları engelle, iradenin ötesine odaklan`)
};

const zh_cn_onboarding_paywall_benefit_custom_app_block_list = /** @type {(inputs: Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`封锁分心软件 ，专注不只靠意志`)
};

const zh_tw_onboarding_paywall_benefit_custom_app_block_list = /** @type {(inputs: Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`封鎖分心 app ，專注不只靠意志`)
};

/**
* | output |
* | --- |
* | "Block distracting apps, focus beyond willpower" |
*
* @param {Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_benefit_custom_app_block_list = /** @type {((inputs?: Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Benefit_Custom_App_Block_ListInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_benefit_custom_app_block_list(inputs)
	if (locale === "ar") return ar_onboarding_paywall_benefit_custom_app_block_list(inputs)
	if (locale === "de") return de_onboarding_paywall_benefit_custom_app_block_list(inputs)
	if (locale === "es") return es_onboarding_paywall_benefit_custom_app_block_list(inputs)
	if (locale === "fr") return fr_onboarding_paywall_benefit_custom_app_block_list(inputs)
	if (locale === "it") return it_onboarding_paywall_benefit_custom_app_block_list(inputs)
	if (locale === "ja") return ja_onboarding_paywall_benefit_custom_app_block_list(inputs)
	if (locale === "ko") return ko_onboarding_paywall_benefit_custom_app_block_list(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_benefit_custom_app_block_list(inputs)
	if (locale === "ru") return ru_onboarding_paywall_benefit_custom_app_block_list(inputs)
	if (locale === "th") return th_onboarding_paywall_benefit_custom_app_block_list(inputs)
	if (locale === "tr") return tr_onboarding_paywall_benefit_custom_app_block_list(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_benefit_custom_app_block_list(inputs)
	return zh_tw_onboarding_paywall_benefit_custom_app_block_list(inputs)
});